<template>
  <div class="order-detail" :class="{ 'order-detail-popup': popupMode }">
    <!-- <div class="stack-moveUp">
        <span class="icon">&rsaquo;</span>
    </div> -->
    <div class="stack title-stack stack-wrapper">
      <MainTitle :status="orderDetail.status" :order="orderDetail">
        <!-- <div class="popup-off" v-if="popupMode" @click="onClickDetail">
          <span>&#10005;</span>
        </div> -->
      </MainTitle>
    </div>
    <!-- {{orderDetail}} -->

    <div class="title-stack stack-wrapper">
      <a
        v-if="!hiddenAds && partner"
        class="banner"
        target="_blank"
        :href="partner.redirect_url"
        ><img :src="partner.banner_image_url" alt="banner"
      /></a>
      <span v-else class="skeleton-box" style="width:100%;height:130px;"></span>
    </div>

    <div class="title-stack stack-wrapper">
      <a
        v-if="!hiddenAds && bannerAiBot"
        target="_blank"
        class="banner"
        :href="bannerAiBot.redirect_url"
        ><img :src="bannerAiBot.banner_image_url" alt="ai-banner"
      /></a>
    </div>

    <div class="stack order-stack stack-wrapper">
      <SupplierInfo
        v-if="orderDetail.supplier_name"
        :name="orderDetail.supplier_name"
        :imageUrl="orderDetail.supplier_avatar"
        :initRate="orderDetail.supplier_rating"
        :plateNumber="orderDetail.supplier_plate_number"
        :phoneNumber="orderDetail.supplier_id || undefined"
        :disablePhone="orderDetail.isOrderCompleted"
        :isRide="orderDetail.order_type === this.$constants.ORDER_TYPE.RIDE"
      />
      <Rating
        v-if="statusCompleted || $route.params.tracking_number"
        :initRate="rate"
        :initComment="orderDetail.comment_by_receiver"
        @onSubmit="handleRatingSupplier"
        @onClick="handleClickRating"
        :isRide="orderDetail.order_type === this.$constants.ORDER_TYPE.RIDE"
      />

      <!-- <RatingModal ref="ratingModal" :order="orderDetail" :initRate="initRate" /> -->

      <div class="stack-more" @click="onClickDetail">
        <span class="text">{{ $t("SHARE_ORDER.details") }}</span>
        <span class="icon">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#f37336"
              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
            />
          </svg>
        </span>
      </div>
      <div
        class="stack-items-full-wrapper"
        :class="{ 'border-top': orderDetail.supplier_name }"
      >
        <TrackingNumber
          v-if="orderDetail.tracking_number"
          :trackingNumber="orderDetail.tracking_number"
        />
        <StatusProcess :data="orderDetail" />
        <Destination
          :distance="orderDetail.distance"
          :data="destinationList"
          :currency="orderDetail.currency"
          :tracking="!orderDetail.tracking_number"
          :stopPoint="orderDetail.stopPoint"
          :isRide="orderDetail.order_type === this.$constants.ORDER_TYPE.RIDE"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MainTitle from "./MainTitle";
import StatusProcess from "./StatusProcess";
import SupplierInfo from "./SupplierInfo";
import Destination from "./Destination";
import TrackingNumber from "./TrackingNumber";
import Rating from "./Rating";

// const DEFAULT_BANNER_IMG = "https://vncdn.ahamove.com/test/d2cf6947bcd7e213333732df2b35ed9ad604fd31.jpg";
// const DEFAULT_BANNER_URL = "https://ahamove.onelink.me/fmLb/t6nqcyiz";

const DEFAULT_BANNER_IMG =
  "https://vncdn.ahamove.com/ahamoveimg/banners/order-tracking-new-9k-9-ma.png";
const DEFAULT_BANNER_URL = "https://ahamove.onelink.me/fmLb/5vw5mnii";

export default {
  name: "OrderDetail",
  components: {
    StatusProcess,
    MainTitle,
    SupplierInfo,
    Destination,
    TrackingNumber,
    Rating,
  },
  data() {
    return {
      popupMode: true,
      isSwitched: false,
      initRate: null,
      partner: null,
      bannerAiBot: null,
    };
  },
  computed: {
    orderDetail: {
      cache: false,
      get() {
        return this.$store.state.order_detail;
      },
    },
    orderStatus() {
      return this.$store.state.order_detail.status;
    },
    statusCompleted() {
      return (
        this.$store.state.order_detail.status ===
        this.$constants.ORDER_STATUS.COMPLETED
      );
    },
    destinationList: {
      cache: false,
      get() {
        return this.$store.getters.destinationList;
      },
    },
    // supplierImageUrl: {
    //   cache: false,
    //   get() {
    //     return `${process.env.VUE_APP_API_URL}${this.$constants.API.supplier.file}?id=${this.orderDetail.supplier_id}&file_id=avatar&size=128`;
    //   },
    // },
    rate() {
      return this.$store.state.rate;
    },
    hiddenAds() {
      if (this.$route.query.banner_url) {
        return false;
      }
      return this.$route.query.ads && this.$route.query.ads === "false";
    },
  },
  methods: {
    redirectToPage(link) {
      const url = link.replace("{order_id}", this.$route.params.order_id);
      window.open(url, "_blank");
    },
    handleClickRating(value) {
      if (!this.rate) {
        this.$emit("showModal", value);
        // this.$refs.ratingModal.visibleRatingModal = true
        // this.$refs.ratingModal.visibleRatingDriver =  true
        // this.$refs.ratingModal.ratingForDriver =  true

        // this.initRate = value
      }
    },
    onClickDetail() {
      this.popupMode = !this.popupMode;
    },
    handleRatingSupplier(rate, comment) {
      const { user_id, orderId } = this.orderDetail;

      if (this.$route.params.tracking_number) {
        const path_index =
          this.orderDetail &&
          this.orderDetail.path &&
          this.orderDetail.path.length > 0 &&
          this.orderDetail.path[1].path_index;
        if (user_id && orderId) {
          this.$store.dispatch("ratingSupplier", {
            userId: user_id,
            orderId,
            rate,
            comment,
            pathIndex: path_index,
          });
        }
      } else {
        if (user_id && orderId) {
          this.$store.dispatch("ratingSupplier", {
            userId: user_id,
            orderId,
            rate,
            comment,
          });
        }
      }
    },
    getConfigPartner(partner) {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_API_EP_URL}/onwheel-utils/staging/util/v1/tracking_page_config_by_partner`;

        window.axios
          .get(url, { params: { partner } })
          .then((response) => {
            if (
              response &&
              response.status === 200 &&
              response.data &&
              response.data[partner]
            ) {
              resolve(response.data[partner]);
              return response.data[partner];
            }
            reject(response);
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
  },
  beforeMount() {
    if (
      this.orderDetail.rating_by_receiver ||
      this.orderDetail.rating_by_receiver !== 0
    ) {
      this.$store.dispatch("setRate", this.orderDetail.rating_by_receiver);
    }
  },
  async mounted() {
    const isAsimov = this.orderDetail.service_id.includes("ASIMOV");
    const isAiBotOrder = this.orderDetail.service_id.includes("AIBOT");
    if (isAiBotOrder) {
      this.bannerAiBot = {
        banner_image_url:
          "https://vncdn.ahamove.com/ahamoveimg/banners/aha-food-banner_2.webp",
        redirect_url: "https://home.ahamove.com/aha-ai-chatbot/",
      };
    }

    if (this.$route.query.partner || isAsimov) {
      const partner = isAsimov ? "asimov" : this.$route.query.partner;

      this.getConfigPartner(partner)
        .then((response) => {
          this.partner = {
            banner_image_url: response.banner_image_url || DEFAULT_BANNER_IMG,
            redirect_url: response.redirect_url || DEFAULT_BANNER_URL,
          };
        })
        .catch(() => {
          this.partner = {
            banner_image_url: DEFAULT_BANNER_IMG,
            redirect_url: DEFAULT_BANNER_URL,
          };
        });
    } else {
      this.partner = {
        banner_image_url: DEFAULT_BANNER_IMG,
        redirect_url: DEFAULT_BANNER_URL,
      };
    }
    if (
      this.$route.params.tracking_number &&
      this.orderDetail &&
      this.orderDetail.path &&
      Array.isArray(this.orderDetail.path) &&
      this.orderDetail.path.length >= 1 &&
      this.orderDetail.path[1] &&
      this.orderDetail.path[1].rating_by_receiver
    ) {
      const rate = this.orderDetail.path[1].rating_by_receiver;
      this.$store.dispatch("setRate", rate);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.banner {
  border-radius: 4px;
}
.order-detail {
  background: #f2f4f8;
  padding: 0 8px;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 375px;
  height: 100vh;
  min-width: 21rem;
  overflow-y: auto;
  // transition: background-color 0.1s,width 0.25s ease-in-out;

  // .stack-moveUp {
  //     position: fixed;
  //     padding-top: 0.6rem;
  //     top: 0;
  //     left: calc(50% - 18px);
  //
  //     .icon {
  //         font-size: 31px;
  //         line-height: 24px;
  //         transform: rotate(-90deg);
  //         color: #f37336;
  //         height: 36px;
  //         width: 36px;
  //         background: #fff;
  //         border: 1px solid #fff;
  //         border-radius: 18px;
  //         box-shadow: 0 2px 6px 0 rgba(28,28,28,.1);
  //     }
  // }

  .title-stack {
    .popup-off {
      display: flex;
      align-items: center;
      padding-left: 0.6rem;
      margin-left: 0.6rem;
      font-size: 20px;
      border-left: 1px solid #ccd6dd;
      cursor: pointer;
    }
    .banner {
      display: block;
      border-radius: 6px;
      overflow: hidden;
      box-shadow: 0 2px 6px 0 rgba(28, 28, 28, 0.1);
      img {
        display: block;
        object-fit: cover;
        width: 100%;
        height: auto;
      }
    }
  }

  .stack {
    display: flex;
    pointer-events: auto;
    flex-direction: column;
    flex-shrink: 0;
    width: 100%;
    background: #fff;
    box-shadow: 0 2px 6px 0 rgba(28, 28, 28, 0.1);
    padding: 0.6rem;

    .stack-item:not(:first-child) {
      border-top: 4px solid #f5f7fa;
    }
  }

  .stack-wrapper {
    margin-top: 8px;
    border-radius: 6px;
  }

  .stack-wrapper:last-of-type {
    margin-bottom: 12px;
  }

  .order-stack {
    .stack-more {
      display: none;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding-top: 4px;

      .text {
        font-size: 14px;
        color: #f37336;
        font-weight: 500;
      }
      .icon {
        font-size: 31px;
        line-height: 24px;
      }
    }

    .border-top {
      .stack-item {
        border-top: 4px solid #f5f7fa;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .order-detail {
    width: 100%;
    min-width: initial;
    top: initial;
    bottom: 0;
    left: 0;
    padding: 0 8px 12px;
    height: initial;
    overflow-y: initial;
    max-width: initial;

    .order-stack {
      .stack-more {
        display: flex;
      }

      .stack-items-full-wrapper {
        display: none;
      }
    }

    .stack-wrapper:last-of-type {
      margin-bottom: 0;
    }
  }

  .order-detail-popup {
    bottom: initial;
    width: 100vw;
    left: 0;
    max-width: 100vw;
    padding: 0 8px 12px;
    min-height: 100vh;

    .order-stack {
      .stack-more {
        display: none;
      }

      .stack-items-full-wrapper {
        display: initial;
      }
    }
  }

  @media only screen and (max-height: 360px) {
    .order-detail {
      display: none;
    }
  }

  @media only screen and (max-height: 479px) {
    .order-detail {
      .title-stack,
      .order-stack > :nth-child(n) {
        display: none;
      }

      .order-stack {
        .stack-more {
          display: flex;
        }
      }
    }

    .order-detail-popup {
      .title-stack,
      .order-stack > :nth-child(n) {
        display: flex;
      }

      .order-stack {
        .rating {
          display: unset;
        }
      }

      .order-stack {
        .stack-more {
          display: none;
        }

        .stack-items-full-wrapper {
          display: initial;
        }
      }
    }
  }
}

.skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #dddbdd;
  border-radius: 6px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 5s infinite;
    content: "";
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
